export const walletCurrent = 'wallet:current';
export const walletProfitLossBalance = 'wallet:profitlossbalance';
export const walletNetDeposits = 'wallet:netdeposits';
export const walletHistoryCommand = 'wallet:history';
export const walletCurrency = 'wallet:currency';
export const paymentsMethodsList = 'payments:methods:list';
export const paymentsDepositsDeposit = 'payments:deposits:deposit';
export const paymentsWithdrawalsList = 'payments:withdrawals:list';
export const paymentsWithdrawalsWithdraw = 'payments:withdrawals:withdraw';
export const paymentsWithdrawalsCancel = 'payments:withdrawals:cancel';
